import { Box, Typography } from "@mui/material";

type PermissionStatusProps = {
  canCall: boolean;
};

export const PermissionStatus = ({ canCall }: PermissionStatusProps) => {
  let bgColor;
  let borderColor;
  let textColor;
  let text;

  switch (canCall) {
    case true:
      bgColor = "success.extraLighter"; // Yeşil arkaplan rengi
      borderColor = "#00B0A6"; // Yeşilin daha koyu bir tonu
      textColor = "success.main"; // Yeşilin daha yoğun bir tonu
      text = "Yetki Var";
      break;

    case false:
      bgColor = "warning.extraLighter";
      borderColor = "#ffb800";
      textColor = "warning.main";
      text = "Yetki Yok";
      break;

    default:
      // Bu durum teorik olarak canCall true veya false olmadığı sürece oluşmamalıdır.
      bgColor = "grey.lighter"; // Varsayılan arkaplan rengi
      borderColor = "grey"; // Varsayılan çerçeve rengi
      textColor = "text.primary"; // Temanın varsayılan metin rengi
      text = "Bilinmiyor"; // Varsayılan metin
      break;
  }

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: 35,
        width: 90,
        borderRadius: 2,
        backgroundColor: bgColor,
        border: `1px solid ${borderColor}`,
        color: textColor,
      
      }}
    >
      <Typography variant="caption"  component="div" sx={{ color: textColor,fontWeight: 'bold',  fontSize: '0.700rem', }}>
        {text}
      </Typography>
    </Box>
  );
};
